import  { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";
import { get, remove } from "../Services/LocalStorageService";
import axiosClient from "../AxiosClient";
import { addDoctorData } from "../Redux/SliceAuthDoctor";

const DoctorsConfirmationGuard = ({children}) => {
  const AuthDoctorData = useSelector((state) => state.AuthDoctor);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      AuthDoctorData.isAuthenticated &&
      get("TOKEN_DOCTOR") &&
      !AuthDoctorData.doctor
    ) {
      axiosClient
        .get("/doctor")
        .then((re) => {
          dispatch(addDoctorData(re.data));
        })
        .catch((er) => {
          console.log(er);
          remove("TOKEN_DOCTOR")
          navigate("/doctor/login");
        });
    }
  }, [dispatch, navigate, AuthDoctorData]);

  if (!AuthDoctorData.isAuthenticated || !get("TOKEN_DOCTOR")) {
    return <Navigate to="/doctor/login" replace />;
  }

  // Wait for the doctor data before deciding
  if (!AuthDoctorData.doctor) {
    return null;
  }

  if (AuthDoctorData.doctor.email_verified_at !== null) {
    return <Navigate to="/doctor/dashboard" replace />;
  }

  return children;
};

export default DoctorsConfirmationGuard;
